//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CaseDetailItem from "./case";
import RewardModal from "./RewardModal/index.vue";
export default {
  name: "UnpackgameInstanceItem",
  props: {
    value: {
      type: Boolean,
      defalut: false,
    },
    gameInstanceId: {
      type: Number,
    },
    muxiangCaseId: {
      type: Number,
      defalut: "",
    },
    type: {
      type: String,
      defalut: "accumulate",
    },
  },
  components: {
    "caseDetail-item": CaseDetailItem,
    "c-RewardModal": RewardModal,
  },
  model: {
    prop: "value",
    event: "on-sync",
  },
  data() {
    return {
      showDialog: false,
      unpackgameInstanceItemBg: require("@/assets/images/case/bg-2-m.jpg"),
      unpackgameInstanceItemBorder: require("@/assets/images/case/bg-border.png"),
      cumulative_bonus_Pic: require("@/assets/images/cumulative_bonus.png"),
      average_Pic: require("@/assets/images/average_pic.png"),
    };
  },
  watch: {
    value(v) {
      if(v){
        setTimeout(()=>{
          this.showDialog = v;
        },500)
      }
    },
    showDialog(v) {
      this.$emit("on-sync", v);
    },
  },
  methods: {
    onCloseHand() {
      this.showDialog = false;
    },
    onRewardModalCloseHandle(data) {
      this.$emit("on-unpackgameInstanceClose", data);
    },
  },
};
